import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { FriendlySelectionFormModel } from '../../models/friendly-selection/friendly-selection-form-model';
import { areEqualIgnoreCase } from '../../../../../../core/functions/string-helpers';
import { AddFriendliesResult } from './models/add-friendlies-result';

@Injectable({
    providedIn: 'root',
})
export class FriendlySelectionFormService {
    getFormDefinition(): FormGroup<FormGroupType<FriendlySelectionFormModel>> {
        return new FormGroup<FormGroupType<FriendlySelectionFormModel>>({
            identifier: new FormControl<string | null>(null),
        });
    }

    isFriendlyAlreadyAdded(
        formArray: FormArray<
            FormGroup<FormGroupType<FriendlySelectionFormModel>>
        >,
        entity: FriendlySelectionFormModel,
    ): boolean {
        return formArray.value.some((x) =>
            areEqualIgnoreCase(x.identifier, entity.identifier),
        );
    }

    /**
     * Adds all entities to the friendly selection form array that are not already added.
     * @param formArray
     * @param entities
     * @returns
     */
    addAllToFriendlySelection(
        formArray: FormArray<
            FormGroup<FormGroupType<FriendlySelectionFormModel>>
        >,
        entities: FriendlySelectionFormModel[],
    ): AddFriendliesResult {
        const result: AddFriendliesResult = {
            friendliesAdded: 0,
            friendliesAlreadyAdded: 0,
        };

        const newFormControls: FormGroup<
            FormGroupType<FriendlySelectionFormModel>
        >[] = [];

        entities.forEach((entity) => {
            const friendlyAlreadyAdded = this.isFriendlyAlreadyAdded(
                formArray,
                entity,
            );

            if (friendlyAlreadyAdded) {
                result.friendliesAlreadyAdded++;
            } else if (
                !newFormControls.some((x) =>
                    areEqualIgnoreCase(x.value.identifier, entity.identifier),
                )
            ) {
                const friendlyToAdd = this.getFormDefinition();
                friendlyToAdd.patchValue(entity);
                newFormControls.push(friendlyToAdd);

                result.friendliesAdded++;
            }
        });

        newFormControls.forEach((control) => formArray.push(control));

        return result;
    }
}
